/**
 * Shared helper used by both `HomeSections.js` and `HeroOverlays.js`.
 * Extracted to break the circular import between the two files.
 */
export function resolveImg(url) {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  if (url.startsWith('/')) {
    return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  }
  return url;
}
